import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getDatabase, ref, set, get, update, remove } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage, uploadBytes, getDownloadURL, ref as storageRef } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBLm9XcW4c8-PyRAoGBmVNlNypaWvvFJtk",
  authDomain: "personaldev-72845.firebaseapp.com",
  projectId: "personaldev-72845",
  storageBucket: "personaldev-72845.firebasestorage.app",  // Correct bucket name
  messagingSenderId: "587784641725",
  appId: "1:587784641725:web:73a92729e18c99d4d0ebd4",
  measurementId: "G-W6K0XLY6XV"
};


// Initialize Firebase app
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Get Firestore and Realtime Database
const dbFirestore = getFirestore(app);
const dbRealtime = getDatabase(app);
const storage = getStorage(app);
const functions = getFunctions(app, "us-central1");

// ✅ Export Realtime Database as 'db' by default
export const db = dbRealtime;

// Other named exports
export { app, dbFirestore, dbRealtime, ref, set, get, update, remove, auth, storage, uploadBytes, getDownloadURL, storageRef, functions };
